(function () {
    "use strict";

    angular
        .module("app.sales")
        .controller("SalesPaymentController", SalesPaymentController);

    SalesPaymentController.$inject = [
        "$scope",
        "$timeout",
        "CartService",
        "GeneralService",
        "CustomerAddressService",
        "CustomerGeneralService",
        "SalesPaymentService",
        "AccountService",
        "SharedData",
    ];

    function SalesPaymentController(
        $scope,
        $timeout,
        CartService,
        GeneralService,
        CustomerAddressService,
        CustomerGeneralService,
        SalesPaymentService,
        AccountService,
        SharedData
    ) {
        var vm = this;
        vm.success = false;
        vm.newCustomerAddress = {};
        vm.newGuestCustomerAddress = {
            MessageStatus: true,
            AddressType: "INDIVIDUAL",
        };
        vm.frmUserAddressSave = {
            AddressType: "INDIVIDUAL",
        };
        vm.VendorLocation = {};
        vm.isAuthenticated = false;
        vm.pay = {
            CreditCardPaymentOption: "00",
            CardNumber: undefined,
            Aggree: false,
            ThreeDType: true,
        };
        vm.loading = false;
        vm.SharedData = SharedData;
        vm.tabIndex = 0;
        vm.salesOrderType = "sales";
        vm.tabOneDisable = false;
        vm.tabTwoDisable = false;
        vm.accorionStatus = [];
        vm.accorionStatus["_creditcard"] = {
            open: true,
        };
        vm.addressSaved = true;

        var fastBuy = $.Url.QueryString("fastBuy");
        vm.belowMinPriceValue = true;
        vm.checkoutCreditCardMinPriceValue = true;
        vm.checkoutStep = 1;
        vm.paymentTabStep = 0;
        vm.cargoSelect = false;
        vm.payButtonLoader = false;
        vm.SpecialCargo = false;

        function activate() {
            GeneralService.getStateProvince().then(function (response) {
                vm.getStateProvince = response.data;
            });

            GeneralService.getCountry().then(function (response) {
                vm.getCountry = response.data;
            });

            GeneralService.getCountryOfSalesPoint().then(function (response) {
                if (response.data.length > 1) {
                    vm.getCountryOfSalesPoint = response.data;
                } else {
                    GeneralService.getStateProvinceOfSalesPointWithoutCountry().then(
                        function (response) {
                            vm.getStateProvinceOfSalesPoint = response.data;
                        }
                    );
                }
            });

            GeneralService.getSalesPoints().then(function (response) {
                vm.getSalesPoint = response.data;
            });

            $scope.$watch("vm.pay.ExpirationTemp", function (value) {
                if (value && value.length == 4) {
                    var expMonthVal = value.toString().substring(0, 2);
                    var expYearVal = value.toString().substring(2, 4);
                    vm.pay.ExpirationMonth = expMonthVal;
                    vm.pay.ExpirationYear = expYearVal;
                }
            });

            $scope.$watch("vm.pay.Total", function (value) {
                if (vm.cart && vm.salesOrderType === "direct") {
                    vm.cart.TotalWithDiscount = value || 0;
                }
            });

            $scope.$watch("vm.pay.DeliveryDateTemp", function (value) {
                vm.pay.DeliveryDate = moment(vm.pay.DeliveryDateTemp).format(
                    "DD/MM/YYYY"
                );
            });

            $scope.$watch("vm.pay.CreditCardPaymentOption", function (value) {
                if (value) {
                    var valueArray = value.split("_");
                    if (valueArray.length > 1) {
                        vm.pay.Installment = valueArray[0];
                        vm.pay.BankId = valueArray[1];
                        vm.pay.InstallmentId = valueArray[2];
                    } else {
                        vm.pay.Installment = "00";
                        vm.pay.BankId = vm.DefaultCheckoutBank
                            ? vm.DefaultCheckoutBank.Id
                            : "";
                    }
                    if (vm.ActiveBank && vm.ActiveBank.Bank.Installment) {
                        var commison = vm.ActiveBank.Bank.Installment.find(
                            (x) => x.Id == vm.pay.InstallmentId
                        ).Commission;
                        vm.pay.Commission = commison;
                    }
                }
            });

            $scope.$watch("vm.pay.CardNumber", function (newValue, oldValue) {
                vm.pay.cartType = vm.getCreditCardType(newValue);
                vm.pay.cartMask = vm.getMaskType(vm.pay.cartType);
                if (newValue) {
                    var newbin = (newValue || "")
                        .replace(" ", "")
                        .substring(0, 8);
                    var oldbin = (oldValue || "")
                        .replace(" ", "")
                        .substring(0, 8);
                    if (newbin !== oldbin && newbin.length > 7) {
                        SalesPaymentService.getBanktype(
                            newbin,
                            vm.cart.TotalWithDiscount,
                            vm.salesOrderType === "direct" ||
                                vm.salesOrderType === "debt"
                        ).then(function (data) {
                            vm.ActiveBank = data;
                            if (
                                vm.ActiveBank.Bank &&
                                vm.ActiveBank.Bank.Installment
                            ) {
                                var oneInstallment =
                                    vm.ActiveBank.Bank.Installment.find(
                                        function (item) {
                                            return item.BankInstallment == 1;
                                        }
                                    );
                                vm.pay.CreditCardPaymentOption =
                                    "1_" +
                                    vm.ActiveBank.Bank.Id +
                                    (oneInstallment
                                        ? "_" + oneInstallment.Id
                                        : "");
                                vm.pay.ThreeDType = vm.ActiveBank.Bank
                                    .ThreeDType
                                    ? vm.ActiveBank.Bank.ThreeDType
                                    : true;
                            } else if (
                                vm.ActiveBank.Bank &&
                                !vm.ActiveBank.Bank.Installment
                            ) {
                                vm.pay.CreditCardPaymentOption =
                                    "1_" + vm.ActiveBank.Bank.Id;
                                vm.pay.ThreeDType = vm.ActiveBank.Bank
                                    .ThreeDType
                                    ? vm.ActiveBank.Bank.ThreeDType
                                    : true;
                            } else {
                                vm.pay.CreditCardPaymentOption =
                                    "1_" + vm.defaultCheckoutBank.Id;
                                vm.pay.ThreeDType = vm.defaultCheckoutBank
                                    .ThreeDType
                                    ? vm.defaultCheckoutBank.ThreeDType
                                    : true;
                            }
                        });
                    }
                }
            });
            $scope.$watch("vm.pay.Total", function () {
                if (vm.pay.CardNumber) {
                    var newbin = vm.pay.CardNumber.replace(" ", "").substring(
                        0,
                        8
                    );
                    if (newbin.length > 5 && vm.pay.Total > 0) {
                        SalesPaymentService.getBanktype(
                            newbin,
                            vm.cart.TotalWithDiscount,
                            vm.salesOrderType === "direct" ||
                                vm.salesOrderType === "debt"
                        ).then(function (data) {
                            vm.ActiveBank = data;
                            if (
                                vm.ActiveBank.Bank &&
                                vm.ActiveBank.Bank.Installment
                            ) {
                                var oneInstallment =
                                    vm.ActiveBank.Bank.Installment.find(
                                        function (item) {
                                            return item.BankInstallment == 1;
                                        }
                                    );
                                vm.pay.CreditCardPaymentOption =
                                    "1_" +
                                    vm.ActiveBank.Bank.Id +
                                    (oneInstallment
                                        ? "_" + oneInstallment.Id
                                        : "");
                                vm.pay.ThreeDType = vm.ActiveBank.Bank
                                    .ThreeDType
                                    ? vm.ActiveBank.Bank.ThreeDType
                                    : true;
                            } else if (
                                vm.ActiveBank.Bank &&
                                !vm.ActiveBank.Bank.Installment
                            ) {
                                vm.pay.CreditCardPaymentOption =
                                    "1_" + vm.ActiveBank.Bank.Id;
                                vm.pay.ThreeDType = vm.ActiveBank.Bank
                                    .ThreeDType
                                    ? vm.ActiveBank.Bank.ThreeDType
                                    : true;
                            } else {
                                vm.pay.CreditCardPaymentOption =
                                    "1_" + vm.defaultCheckoutBank.Id;
                                vm.pay.ThreeDType = vm.defaultCheckoutBank
                                    .ThreeDType
                                    ? vm.defaultCheckoutBank.ThreeDType
                                    : true;
                            }
                        });
                    }
                }
            });
            $scope.$watch("vm.pay.BankId", function (newValue) {
                if (vm.banks) {
                    var bank = vm.banks.find(function (item) {
                        return item.Id === newValue;
                    });
                    vm.selectedBank = bank;
                    if (vm.cart && vm.cart.Id) {
                        vm.cart.SelectedBankId = vm.selectedBank.Id;
                        vm.updateCart();
                    }
                }
            });

            $scope.$watchCollection(
                "[vm.deliveryAddress.Id,vm.billAddress.Id]",
                function (newValue, oldValue) {
                    if (vm.cart) {
                        vm.cart.InvoiceAddressId =
                            vm.billAddress != null ? vm.billAddress.Id : null;
                        vm.cart.DeliveryAddressId =
                            vm.deliveryAddress != null
                                ? vm.deliveryAddress.Id
                                : null;
                        vm.updateCart().then(function () {
                            var findShipmentPrice =
                                vm.cart.CalculatedShippingPrice.find(
                                    (t) =>
                                        t.ShipmentProvider.Id ===
                                        vm.cart.ShipmentProviderId
                                );
                            if (!findShipmentPrice) {
                                vm.cart.CalculatedShippingPrice.sort(function (
                                    a,
                                    b
                                ) {
                                    return (
                                        a.PriceWithDiscount -
                                        b.PriceWithDiscount
                                    );
                                });
                                if (
                                    vm.cart.CalculatedShippingPrice &&
                                    vm.cart.CalculatedShippingPrice.length > 0
                                ) {
                                    vm.cart.ShipmentProviderId =
                                        vm.cart.CalculatedShippingPrice[0].ShipmentProvider.Id;
                                }
                                vm.updateCart();
                            }
                        });
                    }
                }
            );

            $scope.$watchCollection(
                "[vm.cart.Id,vm.customerAddresses]",
                function (newValue, oldValue) {
                    if (vm.cart && vm.customerAddresses) {
                        if (fastBuy == "true") {
                            vm.cart.DeliveryAddressId = vm.deliveryAddress.Id;
                            vm.cart.InvoiceAddressId = vm.billAddress.Id;
                        }
                        if (vm.cart.DeliveryAddressId) {
                            var selectedAdress = vm.customerAddresses.find(
                                function (item) {
                                    return item.Id == vm.cart.DeliveryAddressId;
                                }
                            );
                            vm.deliveryAddress = selectedAdress;
                        }
                        if (vm.cart.InvoiceAddressId) {
                            var selectedAdress = vm.customerAddresses.find(
                                function (item) {
                                    return item.Id == vm.cart.InvoiceAddressId;
                                }
                            );
                            vm.billAddress = selectedAdress;
                        } else if (vm.deliveryAddress) {
                            vm.billAddress = vm.deliveryAddress;
                        }
                    }
                }
            );

            $("#paymentModal").on("hidden.bs.modal", function (e) {
                $("#loading").attr("style", "display:flex !important");
                var url = window.location.href;
                if (
                    url.contains("/Checkout/Checkout") &&
                    !$("#paymentModalBody")
                        .find("iframe")
                        .contents()
                        .find("body")
                        .hasClass("error-result")
                ) {
                    location.href = "/";
                } else {
                    location.href = url;
                }
            });

            $timeout(function () {
                if (vm.salesOrderType === "direct") {
                    vm.getCustomerAddresses();
                    vm.cart = {
                        TotalWithDiscount: 0.0,
                    };
                    vm.pay.Total = 0.0;
                    vm.tabIndex = 0;
                    window.scroll(0, 0);
                    vm.loading = false;
                    vm.getBanks();
                } else if (vm.salesOrderType === "debt") {
                    vm.getCustomerAddresses();
                    vm.cart = {
                        TotalWithDiscount: generalVariable.debtTotal,
                    };
                    vm.pay.Total = generalVariable.debtTotal;
                    vm.pay.Description = generalVariable.debtDescription;
                    vm.tabIndex = 0;
                    window.scroll(0, 0);
                    vm.loading = false;
                    vm.getBanks();
                } else {
                    vm.getCustomerAddresses();
                    if (vm.isAuthenticated) {
                        if (fastBuy === "true") {
                            vm.tabIndex = 2;
                            window.scroll(0, 0);
                        } else {
                            vm.tabOneDisable = true;
                            vm.tabIndex = 1;
                            window.scroll(0, 0);
                            vm.loading = false;
                        }
                    }
                    var cartId = $.Url.QueryString(
                        "cartId",
                        window.location.href
                    );
                    CartService.getCart({
                        Id: cartId,
                    }).then(function (data) {
                        vm.cart = data;
                        vm.cart.SelectedBankId = null;
                        vm.getBanks();
                        vm.pay.OrderNote = vm.cart.Note;
                    });
                }
            });
            SalesPaymentService.getCurrency().then(function (response) {
                vm.currency = response;
            });
            $scope.$watch("vm.cart.CartProduct", function (value) {
                if (value) {
                    vm.checkSpecialCargo();
                }
            });
        }

        $scope.$watchCollection(
            "[vm.cart.InvoiceAddressId,vm.cart.DeliveryAddressId]",
            function () {
                var activateGtm = new ActivateGtm();
                activateGtm.activateChangeShipping();
            }
        );

        vm.getBanks = function () {
            GeneralService.GetBanks().then(function (data) {
                vm.banks = data.data.filter(function (item) {
                    return item.Active === true;
                });

                vm.checkoutBanks = vm.banks.filter(function (item) {
                    return item.UseCheckout;
                });
                vm.directCheckoutBanks = vm.checkoutBanks.filter(function (
                    item
                ) {
                    return item.ShowDirect;
                });
                vm.cartCheckoutBanks = vm.checkoutBanks.filter(function (item) {
                    return item.ShowCart;
                });
                vm.otherBanks = vm.banks.filter(function (item) {
                    return !item.UseCheckout;
                });
                vm.directOtherBanks = vm.otherBanks.filter(function (item) {
                    return item.ShowDirect;
                });
                vm.cartOtherBanks = vm.otherBanks.filter(function (item) {
                    return item.ShowCart;
                });

                vm.transferEFTBanks = data.data.filter(function (item) {
                    return item.TransferEFT && item.UseCheckout;
                });
                vm.defaultCheckoutBank = vm.banks.find(function (item) {
                    return item.Default;
                });
                vm.directBanksInstallment = data.data.filter(function (item) {
                    //Direct Ödemelerde Aktif Bankadan bağımsız taksit göstermek için
                    return item.UseCheckout;
                });
                if (!vm.defaultCheckoutBank.UseCheckout) {
                    vm.accorionStatus["_creditcard"] = {
                        open: false,
                    };
                    vm.accorionStatus[vm.defaultCheckoutBank.Id] = {
                        open: true,
                    };
                }
                vm.pay.ThreeDType = vm.defaultCheckoutBank.ThreeDType
                    ? vm.defaultCheckoutBank.ThreeDType
                    : true;

                vm.pay.BankId = vm.defaultCheckoutBank.Id;
                vm.pay.CreditCardPaymentOption =
                    "1_" + vm.defaultCheckoutBank.Id;
                var tickBank = data.data.filter(function (item) {
                    return item.NormalizeName === "Tick";
                });
                if (tickBank) {
                    CustomerGeneralService.getRemainingTickPrice().then(
                        function (response) {
                            vm.remainingTickPrice = response.data;
                        }
                    );
                }
                var minPriceList = [];
                vm.banks.forEach((bank) => {
                    if (vm.cart.TotalWithDiscount < bank.MinPrice) {
                        vm.belowMinPriceValue = false;
                    } else {
                        vm.belowMinPriceValue = true;
                    }
                    if (bank.MinPrice) {
                        minPriceList.push(bank.MinPrice);
                    }
                });
                vm.bankMinPrice =
                    minPriceList.length > 0
                        ? Math.min.apply(null, minPriceList)
                        : 0;
                vm.checkoutBanks.forEach((checkoutbank) => {
                    if (vm.cart.TotalWithDiscount < checkoutbank.MinPrice) {
                        vm.checkoutCreditCardMinPriceValue = false;
                    } else {
                        vm.checkoutCreditCardMinPriceValue = true;
                    }
                });
            });
        };

        vm.checkoutContractCheck = function (formData) {
            vm.checkoutContract = true;

            var selectedContractIds = [];
            formData.split("&").filter(function (item) {
                if (
                    item.startsWith("SelectedContract-") &&
                    item.endsWith("=on")
                ) {
                    selectedContractIds.push(
                        item.replace("SelectedContract-", "").replace("=on", "")
                    );
                }
            });

            if (vm.requiredContractIds) {
                var requiredContractArr = vm.requiredContractIds.split(",");
                requiredContractArr.forEach(function (item) {
                    if (!selectedContractIds.includes(item)) {
                        vm.checkoutContract = false;
                    }
                });
            }

            selectedContractIds.forEach(function (item) {
                formData += "&SelectedContractIds=" + item;
            });

            return formData;
        };

        vm.checkoutPayment = function () {
            var formData = $('[name="vm.frmPayment"]').serialize();

            formData = vm.checkoutContractCheck(formData);

            if (vm.checkoutContract) {
                vm.loading = true;
                SalesPaymentService.payment(formData)
                    .then(function (data) {
                        vm.loading = false;
                        vm.payButtonLoader = false;
                        if (data.Content) {
                            if (data.UseModal == false) {
                                $("body").html(data.Content);
                                $("body form").submit();
                            } else {
                                var iframe = document.createElement("iframe");
                                var encodedUrl = encodeURI(data.Content);
                                encodedUrl = encodedUrl.replace(/#/g, "%23");
                                iframe.src =
                                    "data:text/html;charset=utf-8," +
                                    encodedUrl;
                                document
                                    .getElementById("paymentModalBody")
                                    .appendChild(iframe);
                                $("#paymentModal")
                                    .modal("show")
                                    .addClass(vm.selectedBank.NormalizedName);
                            }
                        } else if (data.Url) {
                            window.location.href = data.Url;
                        } else {
                            alert("Ödeme Sırasında Hata Oluştu");
                        }
                    })
                    .catch(function (error) {
                        vm.loading = false;
                        vm.payButtonLoader = false;
                        alert(error.data.Message);
                    });
            }
        };

        vm.checkout = function () {
            vm.payButtonLoader = true;
            if (!vm.frmPayment.$valid) {
                return false;
                vm.payButtonLoader = false;
            }
            if (vm.salesOrderType === "direct") {
                if (
                    vm.frmGuestUserAddressSave &&
                    vm.frmGuestUserAddressSave.$valid
                ) {
                    vm.saveGuestUserAddress().then(function (data) {
                        vm.checkoutPayment();
                    });
                } else if (
                    vm.frmUserAddressSave &&
                    vm.frmUserAddressSave.$valid
                ) {
                    vm.saveUserAddress().then(function (data) {
                        vm.checkoutPayment();
                    });
                } else {
                    vm.checkoutPayment();
                }
            } else if (vm.salesOrderType === "debt") {
                if (
                    vm.frmGuestUserAddressSave &&
                    vm.frmGuestUserAddressSave.$valid
                ) {
                    vm.saveGuestUserAddress().then(function (data) {
                        vm.checkoutPayment();
                    });
                } else if (
                    vm.frmUserAddressSave &&
                    vm.frmUserAddressSave.$valid
                ) {
                    vm.saveUserAddress().then(function (data) {
                        vm.checkoutPayment();
                    });
                } else {
                    vm.checkoutPayment();
                }
            } else {
                vm.checkoutPayment();
            }
        };

        vm.selectBank = function (bank, customid) {
            if (customid) {
                vm.pay.BankId = vm.defaultCheckoutBank.Id;
                vm.accorionStatus[customid] = {
                    open: true,
                };
            } else {
                vm.pay.BankId = bank.Id;
                vm.accorionStatus[bank.Id] = {
                    open: true,
                };
                if (vm.accorionStatus["_creditcard"]) {
                    vm.accorionStatus["_creditcard"].open = true;
                }
            }
        };

        vm.currentBank = function (bank) {
            vm.currentBankId = bank.Id;
            vm.paymentTabStep = -1;
        };

        vm.updateCart = function () {
            $(
                vm.cart.CartProduct.filter(function (element) {
                    return element.IsSpecificShipping == false;
                })
            ).each(function (i, item) {
                item.ShipmentProviderId = vm.cart.ShipmentProviderId;
                if (
                    vm.cart.getCurrentShipmentProviderId !=
                    vm.cart.ShipmentProviderId
                ) {
                    vm.VendorLocation.CountryId = null;
                    vm.VendorLocation.StateProvinceId = null;
                    vm.VendorLocation.DistrictId = null;
                    vm.cart.SalesPointId = null;
                    item.SalesPointId = null;
                } else {
                    item.SalesPointId = vm.cart.SalesPointId;
                }
            });

            $(
                vm.cart.CartProduct.filter(function (element) {
                    return (
                        element.IsSpecificShipping == true &&
                        !element.ShipmentProviderId
                    );
                })
            ).each(function (i, element) {
                var shipmentProvider = element.CalculatedShippingPrice.sort(
                    function (a, b) {
                        return a.Price - b.Price;
                    }
                );
                if (shipmentProvider && shipmentProvider.length > 0) {
                    element.ShipmentProviderId =
                        shipmentProvider[0].ShipmentProvider.Id;
                }
            });
            var promiseUpdateCart = CartService.updateCart(vm.cart);
            promiseUpdateCart.then(function (data) {
                vm.cart = data;

                vm.cart.getCurrentShipmentProvider =
                    vm.cart.CalculatedShippingPrice.find(function (item) {
                        return (
                            item.ShipmentProvider.NormalizedName ===
                            "bayiden-teslimat"
                        );
                    });
                if (vm.cart.getCurrentShipmentProvider) {
                    vm.cart.getCurrentShipmentProviderId =
                        vm.cart.getCurrentShipmentProvider.ShipmentProvider.Id;
                }

                vm.getCurrentShipmentProvider(vm.cart.ShipmentProviderId);
            });
            return promiseUpdateCart;
        };

        vm.getCurrentShipmentProvider = function (ShipmentProviderId) {
            if (ShipmentProviderId) {
                GeneralService.getCurrentShipmentProvider(
                    ShipmentProviderId
                ).then(function (response) {
                    if (response) {
                        vm.cart.getCurrentShipmentProvider = response.data;
                        vm.cart.getCurrentShipmentProviderName =
                            response.data.NormalizedName;
                    }
                });
            }
        };

        vm.getCustomerAddresses = function () {
            vm.loading = true;
            CustomerAddressService.getCustomerAddresses().then(function (
                response
            ) {
                if (response && response.length > 0) {
                    if (fastBuy == "true") {
                        vm.deliveryAddress = response[0];
                        vm.billAddress = response[0];
                        vm.tabIndex = 2;
                    } else if (
                        vm.salesOrderType === "direct" ||
                        vm.salesOrderType === "debt"
                    ) {
                        vm.deliveryAddress = response[0];
                        vm.billAddress = response[0];
                        if (vm.deliveryAddress) {
                            vm.newCustomerAddress.Title =
                                vm.deliveryAddress.Title;
                            vm.newCustomerAddress.Phone1 =
                                vm.deliveryAddress.Phone1;
                            vm.newCustomerAddress.StateProvinceId =
                                vm.deliveryAddress.StateProvinceId;
                            vm.newCustomerAddress.DistrictId =
                                vm.deliveryAddress.DistrictId;
                            vm.newCustomerAddress.Description =
                                vm.deliveryAddress.Description;
                            vm.newCustomerAddress.CompanyName =
                                vm.deliveryAddress.CompanyName;
                            vm.newCustomerAddress.TaxOffice =
                                vm.deliveryAddress.TaxOffice;
                            vm.newCustomerAddress.TaxNumber =
                                vm.deliveryAddress.TaxNumber;
                        }
                    } else {
                        vm.tabIndex = 1;
                    }
                    vm.customerAddresses = response.sort(function (a, b) {
                        return new Date(b.UpdateDate) - new Date(a.UpdateDate);
                    });
                    vm.newGuestCustomerAddress = response[0];
                    vm.customer = response.Customer;
                    vm.tabOneDisable = true;
                    if (vm.newGuestCustomerAddress.StateProvinceId) {
                        vm.getStateProvinceChange(
                            vm.newGuestCustomerAddress.StateProvinceId
                        );
                    }
                } else {
                    if (vm.isAuthenticated) {
                        vm.customerAddresses = [];
                        vm.tabIndex = 1;
                        vm.newAddress = true;
                    } else {
                        vm.customerAddresses = [];
                        vm.tabIndex = 0;
                    }
                }
                vm.loading = false;
            });
        };

        vm.goPaymentTab = function () {
            if (vm.isAuthenticated) {
                vm.tabIndex = 2;
                window.scroll(0, 0);
            } else {
                vm.saveGuestUserAddress();
            }
        };

        vm.goAddressTab = function () {
            vm.tabIndex = 1;
            window.scroll(0, 0);
        };

        vm.saveGuestEmail = function () {
            if (vm.frmGuestUserEmail.$valid) {
                vm.loading = true;
                CustomerAddressService.addCustomerAddressWithUser(
                    vm.newGuestCustomerAddress
                ).then(
                    function (address) {
                        vm.newGuestCustomerAddress = address;
                        vm.tabOneDisable = true;
                        vm.tabIndex = 1;
                        window.scroll(0, 0);
                        vm.loading = false;
                    },
                    function (response) {
                        vm.loading = false;
                        vm.saveGuestEmailMessage = response.data.Message;
                    }
                );
            }
        };
        vm.saveMemberLogin = function () {
            if (vm.frmLogin.$valid) {
                vm.loading = true;

                AccountService.login(vm.newLoginModel)
                    .then(function (response) {
                        vm.tabOneDisable = true;
                        vm.tabIndex = 0;
                        window.scroll(0, 0);
                        vm.loading = false;
                        location.href = location.origin + vm.returnUrl;
                    })
                    .catch(function (response) {
                        vm.loading = false;
                        vm.saveMemberEmailMessage =
                            response.data.error_description;
                    });
            }
        };

        activate();

        vm.getCountryChange = function (CountryId) {
            vm.getStateProvince = {};
            if (CountryId) {
                GeneralService.getStateProvinceOfCountry(CountryId).then(
                    function (response) {
                        vm.getStateProvince = response.data;
                    }
                );
            }
        };

        vm.getCountryPointChange = function (CountryId) {
            if (CountryId) {
                GeneralService.getStateProvinceOfSalesPoint(CountryId).then(
                    function (response) {
                        vm.cart.SalesPointId = null;
                        vm.getStateProvinceOfSalesPoint = response.data;
                    }
                );
            }
        };

        vm.getStateProvincePointChange = function (StateProvinceId) {
            if (StateProvinceId) {
                GeneralService.getDistrictOfSalesPoint(StateProvinceId).then(
                    function (response) {
                        vm.cart.SalesPointId = null;
                        vm.getDistrictOfSalesPoint = response.data;
                    }
                );
            }
        };

        vm.getDistrictPointChange = function (DistrictId) {
            if (DistrictId) {
                GeneralService.getSalesPointsWithParameter(DistrictId).then(
                    function (response) {
                        vm.getSalesPoint = response.data;
                    }
                );
            }
        };

        vm.getStateProvinceChange = function (StateProvinceId) {
            if (StateProvinceId) {
                vm.getDistrict = {};
                GeneralService.getDistrict(StateProvinceId).then(function (
                    response
                ) {
                    vm.getDistrict = response.data;
                });
            }
        };

        vm.editStateProvinceChange = function (
            StateProvinceId,
            DistrictId,
            index
        ) {
            if (StateProvinceId) {
                vm.getDistrict = {};
                GeneralService.getDistrict(StateProvinceId).then(function (
                    response
                ) {
                    vm.getDistrict = response.data;
                    vm.customerAddresses[index].DistrictId = DistrictId;
                });
            }
        };

        vm.getDistrictChange = function (DistrictId) {
            if (DistrictId) {
                vm.getCity = {};
                GeneralService.getCity(DistrictId).then(function (response) {
                    vm.getCity = response.data;
                });
            }
        };

        vm.saveUserAddress = async function () {
            if (vm.frmUserAddressSave.$valid) {
                vm.loading = true;
                $(".modal").modal("hide");
                await CustomerAddressService.addCustomerAddress(
                    vm.newCustomerAddress
                ).then(function (response) {
                    vm.newAddress = false;
                    vm.newCustomerAddress = {};
                    vm.sec(response.data);
                    vm.getCustomerAddresses();
                });
                vm.addressSaved = true;
                vm.toggleAddAddress();
            } else {
                vm.addressSaved = false;
            }
        };

        vm.saveGuestUserAddress = async function () {
            vm.loading = true;
            if (vm.frmGuestUserAddressSave.$valid) {
                await CustomerAddressService.addCustomerAddressWithUser(
                    vm.newGuestCustomerAddress
                ).then(
                    function (address) {
                        vm.deliveryAddress = address;
                        vm.billAddress = address;
                        vm.cart.DeliveryAddressId = address.Id;
                        vm.cart.InvoiceAddressId = address.Id;
                        vm.tabIndex = 2;
                        window.scroll(0, 0);
                        vm.loading = false;
                        vm.toggleAddGuestAddress();
                    },
                    function (response) {
                        if (response.status == 500) {
                            alert(response.data.Message);
                            window.history.back();
                        } else {
                            vm.loading = false;
                            vm.saveGuestEmailMessageStep2 =
                                response.data.Message;
                            vm.getCustomerAddresses();
                            vm.toggleAddGuestAddress();
                        }
                    }
                );
            }
        };

        vm.saveGuestUserAddressNew = async function () {
            vm.loading = true;
            if (vm.frmGuestUserAddressSave.$valid) {
                await CustomerAddressService.addCustomerAddressWithUser(
                    vm.newGuestCustomerAddress
                ).then(
                    function (address) {
                        vm.deliveryAddress = address;
                        vm.billAddress = address;
                        vm.cart.DeliveryAddressId = address.Id;
                        vm.cart.InvoiceAddressId = address.Id;
                        vm.tabIndex = 2;
                        vm.cargoSelect = true;
                        vm.loading = false;
                    },
                    function (response) {
                        if (response.status == 500) {
                            alert(response.data.Message);
                            window.history.back();
                        } else {
                            vm.loading = false;
                            vm.saveGuestEmailMessageStep2 =
                                response.data.Message;
                        }
                    }
                );
            }
        };

        vm.sec = function (delAddress) {
            vm.deliveryAddress = delAddress;
            vm.cart.DeliveryAddressId = delAddress.Id;
            if (vm.checked) {
                vm.billAddress = delAddress;
                vm.cart.InvoiceAddressId = delAddress.Id;
            }
        };

        vm.billSec = function (bilAddress) {
            vm.billAddress = bilAddress;
            vm.cart.InvoiceAddressId = bilAddress.Id;
        };

        vm.billdel = function () {
            if (vm.checked) {
                vm.billAddress = vm.deliveryAddress;
                vm.cart.InvoiceAddressId = vm.cart.DeliveryAddressId;
            }
        };

        vm.prepareEdit = function (index) {
            vm.editAddress = true;
            vm.editAddressIndex = index;
            vm.editStateProvinceChange(
                vm.customerAddresses[vm.editAddressIndex].StateProvinceId,
                vm.customerAddresses[vm.editAddressIndex].DistrictId,
                index
            );
            setTimeout(vm.toggleEditAddress(), 1000);
        };

        vm.editUserAddress = function (editAddressIndex) {
            if (vm.frmUserAddressEdit.$valid) {
                vm.loading = true;
                $(".modal").modal("hide");
                CustomerAddressService.editCustomerAddress(
                    vm.customerAddresses[editAddressIndex]
                ).then(function () {
                    vm.editAddress = false;
                    vm.newAddress = false;
                    vm.editAddressIndex = null;
                    vm.getCustomerAddresses();
                });
                vm.addressSaved = true;
                vm.toggleEditAddress();
            } else {
                vm.addressSaved = false;
            }
        };

        vm.deleteUserAddress = function (index) {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                vm.loading = true;
                CustomerAddressService.deleteCustomerAddress(
                    vm.customerAddresses[index]
                ).then(function (response) {
                    vm.getCustomerAddresses();
                    vm.loading = false;
                });
                vm.editAddress = false;
            }
        };

        //// Utils  ///////////////

        vm.getMaskType = function (cardType) {
            var masks = {
                mastercard: "9999 9999 9999 9999",
                visa: "9999 9999 9999 9999",
                amex: "9999 999999 99999",
                diners: "9999 9999 9999 99",
                discover: "9999 9999 9999 9999",
                unknown: "9999 9999 9999 9999",
            };
            return masks[cardType];
        };

        vm.getCreditCardType = function (creditCardNumber) {
            // start without knowing the credit card type
            var result = "unknown";

            // first check for MasterCard
            if (/^5[1-5]/.test(creditCardNumber)) {
                result = "mastercard";
            }
            // then check for Visa
            else if (/^4/.test(creditCardNumber)) {
                result = "visa";
            }
            // then check for AmEx
            else if (/^3[47]/.test(creditCardNumber)) {
                result = "amex";
            }
            // then check for Diners
            else if (/3(?:0[0-5]|[68][0-9])[0-9]{11}/.test(creditCardNumber)) {
                result = "diners";
            }
            // then check for Discover
            else if (/6(?:011|5[0-9]{2})[0-9]{12}/.test(creditCardNumber)) {
                result = "discover";
            }

            return result;
        };

        vm.getFraction = function (x) {
            return (x - Math.floor(x)).toFixed(2).replace("0.", "");
        };

        vm.getDecimal = function (x) {
            return Math.floor(x);
        };

        vm.getInstallmentWithBankInstallment = function (
            installmentList,
            bankInstallment
        ) {
            return installmentList.find(function (x) {
                return x.BankInstallment == bankInstallment;
            });
        };

        vm.getTotalInstallmentAverageDay = function (bank) {
            var dd = vm.pay.Total / vm.general.AmountPassedByCreditCard;
            var total = 0;
            for (let i = 2; i < bank.Installment.length; i++) {
                const item = bank.Installment[i];
                total +=
                    dd * bank.CollectionDaysInstallmentFirstPaymentDay +
                    bank.CollectionDaysInstallmentRepaymentPeriod * (i - 1);
            }
            return total / vm.pay.Total;
        };

        vm.getMainImage = function (product) {
            if (product.FirstImage) {
                return product.FirstImage;
            }
            if (product.ProductMedia) {
                var mainMedia =
                    product.ProductMedia.find(function (media) {
                        return media.IsMain === true;
                    }) || product.ProductMedia[0];
                if (mainMedia) {
                    return mainMedia.Media.FullPath;
                } else {
                    return "no-image.png";
                }
            } else {
                return "no-image.png";
            }
        };

        vm.IsAllProductInStock = function () {
            if (!vm.cart) {
                return false;
            }
            return !vm.cart.CartProduct.some(function (item) {
                return (
                    item.Product.TrackStockQuantity &&
                    item.Product.ClosedForSaleIfOutOfStock &&
                    item.Product.StockQuantity < item.Quantity
                );
            });
        };
        vm.calculateComissionInstallment = function (installment, type) {
            var calculated = 0;
            if (type == "1") {
                calculated =
                    (vm.cart.TotalWithDiscount +
                        vm.cart.TotalWithDiscount *
                            (installment.Commission / 100)) /
                    (installment.ViewInstallment ||
                        installment.BankInstallment ||
                        1);
            } else if (type == "2") {
                calculated =
                    vm.cart.TotalWithDiscount +
                    vm.cart.TotalWithDiscount * (installment.Commission / 100);
            } else if (type == "3") {
                calculated =
                    (vm.cart.TotalWithDiscount +
                        vm.cart.TotalWithDiscount * (0 / 100)) /
                    1;
            } else if (type == "4") {
                calculated =
                    vm.cart.TotalWithDiscount +
                    vm.cart.TotalWithDiscount * (0 / 100);
            }

            return calculated;
        };
        vm.copyBankInfo = function (info) {
            navigator.clipboard.writeText(info);
            $(".copy-info-element").addClass("active");
            setTimeout(function () {
                vm.closeCopyMessage();
            }, 15000);
        };
        vm.closeCopyMessage = function () {
            $(".copy-info-element").removeClass("active");
        };

        vm.ApplyCouponCode = function (couponCode) {
            vm.loading = true;
            CartService.ApplyCoupon(couponCode)
                .then(function (data) {
                    vm.getCart().then(function () {
                        var eventListener = new SelectPromotionEventListener(
                            this
                        );
                        eventListener.callback(
                            vm.SharedData.Cart.CouponCode,
                            vm.SharedData.Cart.GeneralDiscountMessage
                        );
                    });

                    vm.loading = false;
                })
                .catch(function (error) {
                    vm.getCart();
                    vm.loading = false;
                });
        };

        vm.RemoveCouponCode = function () {
            vm.loading = true;
            CartService.RemoveCoupon()
                .then(function (data) {
                    vm.cart.CouponCode = null;
                    vm.getCart();
                    vm.loading = false;
                })
                .catch(function (error) {
                    vm.getCart();
                    vm.loading = false;
                });
        };
        vm.getCart = function (cartType) {
            vm.cartIsEmpty = false;
            var Id = $.Url.QueryString("Id", window.location.href);
            if (userId || getCookieByName("UserKey") || Id) {
                vm.loading = true;
                cartType = cartType || vm.cartType;
                return CartService.getCart({
                    Id: Id,
                    CartType: cartType,
                }).then(function (_cart) {
                    if (cartType === "Compare") {
                        vm.SharedData.Compare = _cart;
                        vm.prepareCompareOptions();
                    } else if (cartType === "Discount") {
                        vm.SharedData.Discount = _cart;
                    } else if (cartType === "Favorite") {
                        vm.SharedData.Favorite = _cart;
                        $timeout(function () {
                            activateSliders(".favorite-product-list-slider");
                        }, 1000);
                    } else if (cartType === "Stock") {
                        angular
                            .element(".mobile-badge")
                            .text(vm.SharedData.Cart.CartProduct.length);

                        if (window.afterGetCart) {
                            window.afterGetCart();
                        }
                        if (vm.analytics) {
                            if (vm.criteoAccountCode)
                                $.Criteo.Basket(_cart, vm.criteoAccountCode);
                        }
                        vm.getCurrentShipmentProvider(vm.SharedData.Cart);
                    } else {
                        vm.SharedData.Cart = _cart;
                        vm.cart = _cart;
                        vm.cartIsEmpty = true;
                        angular
                            .element(".mobile-badge")
                            .text(vm.SharedData.Cart.CartProduct.length);

                        if (window.afterGetCart) {
                            window.afterGetCart();
                        }
                        if (vm.analytics) {
                            if (vm.criteoAccountCode)
                                $.Criteo.Basket(_cart, vm.criteoAccountCode);
                        }
                    }
                    vm.getBanks();
                    vm.show = true;
                    vm.loading = false;
                });
            } else {
                vm.SharedData.Cart = {};
                vm.cartIsEmpty = true;
            }
        };
        vm.toggleEditAddress = function () {
            $("#editAddressShade").toggleClass("end-0");
            $("#editAddressForm").toggleClass("end-0");
        };
        vm.editAddressConfirmPopup = function () {
            $("#edit-address-confirm-popup").modal("show");
        };
        vm.editAddressCancelConfirm = function () {
            vm.toggleEditAddress();
            vm.editAddress = false;
        };
        vm.toggleAddAddress = function () {
            $("#addAddressShade").toggleClass("end-0");
            $("#addAddressForm").toggleClass("end-0");
        };
        vm.toggleAddGuestAddress = function () {
            $("#addGuestAddressShade").toggleClass("end-0");
            $("#addGuestAddressForm").toggleClass("end-0");
        };
        vm.addNewAddress = function () {
            vm.newAddress = true;
            setTimeout(vm.toggleAddAddress(), 1000);
        };
        vm.toggleSummaryMobile = function () {
            $("#summaryPart").toggleClass("end-0");
        };
        vm.closeAddAddress = function () {};
        vm.checkSpecialCargo = function () {
            vm.cart.CartProduct.map((p) => {
                if (p.IsCustomShippingPrice) {
                    vm.SpecialCargo = true;
                }
            });
        };
    }
})();

("BankId=6139db8b-173e-4f4e-90f8-3743c3f2828e&PaymentMethodId=bab50812-0929-44ca-98b9-b415b8619a62&DeliveryAddressId=7efadf60-c44a-454a-f45b-08da9be2f3ec&InvoiceAddressId=7efadf60-c44a-454a-f45b-08da9be2f3ec&Note=&ThreeDType=true&SalesOrderTypeId=9e13af47-bff7-4b39-a1a6-73132251f912&CartId=05a03467-bbb2-4288-aedb-08da9be1b097&SelectedContract-543054a5-849b-40c8-a1f9-983af3c75b34=on&SelectedContract-97270965-df28-44d8-8f60-c16b5eccb7d5=on");
